import { getHostName } from '@office-start/url-parser-utility';
export function isConsumerDocument(url) {
    var hostname = getHostName(url);
    return hostname.lastIndexOf('live.net') > 0;
}
//# sourceMappingURL=isConsumerDocument.js.map